module.exports = __webpack_public_path__ + "brand-icons.5ad3d5d4a4d6acd64df9.svg";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/brand-icons/brand-icons.svg?v=0.3.2
// module id = ../../../../../src/fonts/brand-icons/brand-icons.svg?v=0.3.2
// module chunks = 5